// @flow
import * as React from 'react';
import SailIcon from 'sail/Icon';
import Box from 'sail/Box';

type FrameworkIconProps = {|
  type: string,
|};

const androidIcon = () => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.674 19.288c-.825 0-1.674.66-1.674 1.815 0 1.056.746 1.801 1.674 1.801.766 0 1.107-.512 1.107-.512v.223c0 .106.1.224.224.224h.554v-3.472H2.78v.44s-.344-.52-1.107-.52zm.138.71c.68 0 1.036.596 1.036 1.104 0 .567-.423 1.105-1.034 1.105-.511 0-1.023-.413-1.023-1.112 0-.631.44-1.097 1.021-1.097zM4.64 22.838a.217.217 0 01-.225-.223v-3.249h.778v.43c.176-.264.52-.51 1.049-.51.863 0 1.323.687 1.323 1.33v2.222h-.54a.238.238 0 01-.237-.236v-1.815c0-.356-.219-.789-.725-.789-.545 0-.87.515-.87 1v1.84h-.554zM9.832 19.287c-.825 0-1.674.66-1.674 1.815 0 1.056.746 1.802 1.674 1.802.766 0 1.107-.513 1.107-.513v.224c0 .105.1.223.224.223h.554V17.63h-.778v2.177s-.344-.52-1.107-.52zm.139.71c.679 0 1.035.596 1.035 1.105 0 .566-.423 1.104-1.034 1.104-.51 0-1.023-.413-1.023-1.112 0-.63.44-1.097 1.022-1.097zM12.797 22.839a.217.217 0 01-.224-.224v-3.248h.778v.578a.958.958 0 01.936-.618c.143 0 .276.026.276.026v.803s-.167-.066-.369-.066c-.545 0-.843.515-.843.999v1.75h-.554zM19.282 22.838a.217.217 0 01-.224-.223v-3.249h.777v3.472h-.553zM22.116 19.287c-.826 0-1.674.66-1.674 1.815 0 1.056.746 1.802 1.674 1.802.765 0 1.107-.513 1.107-.513v.224c0 .105.1.223.224.223H24V17.63h-.777v2.177s-.345-.52-1.107-.52zm.138.71c.68 0 1.036.596 1.036 1.105 0 .566-.423 1.104-1.035 1.104-.51 0-1.022-.413-1.022-1.112 0-.63.44-1.097 1.021-1.097zM19.441 18.618a.514.514 0 10.001-1.028.514.514 0 000 1.028zM16.614 19.286c-.864 0-1.814.644-1.814 1.81 0 1.063.81 1.808 1.812 1.808 1.237 0 1.84-.991 1.84-1.8 0-.994-.777-1.818-1.838-1.818zm.003.725c.598 0 1.044.48 1.044 1.088 0 .617-.474 1.093-1.042 1.093-.528 0-1.04-.428-1.04-1.083 0-.666.487-1.098 1.038-1.098z"
        fill="#000"
      />
      <path
        d="M17.858 6.044l1.99-3.44a.403.403 0 00-.147-.55.4.4 0 00-.548.147l-2.016 3.483a12.316 12.316 0 00-5.13-1.092c-1.862 0-3.593.391-5.13 1.092L4.86 2.201a.402.402 0 00-.698.404l1.99 3.439C2.723 7.899.398 11.364.015 15.42h23.984c-.384-4.056-2.708-7.521-6.141-9.376zM6.5 12.059c-.556 0-1.005-.45-1.005-1.003a1.005 1.005 0 012.01 0A1.003 1.003 0 016.5 12.06zm11.01 0c-.556 0-1.005-.45-1.005-1.003a1.005 1.005 0 012.01 0 1.003 1.003 0 01-1.004 1.003z"
        fill="#32DE84"
      />
    </svg>
  );
};

const iosIcon = () => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.177 22.114c-1.193 1.158-2.51.978-3.765.432-1.334-.557-2.554-.593-3.963 0-1.754.757-2.686.537-3.742-.432C.74 15.971 1.62 6.614 8.402 6.262c1.645.088 2.796.91 3.765.978 1.44-.293 2.818-1.132 4.359-1.022 1.852.15 3.236.88 4.161 2.195-3.809 2.29-2.906 7.31.592 8.719-.7 1.838-1.598 3.654-3.104 4.997l.002-.015zM12.035 6.196c-.179-2.73 2.034-4.976 4.58-5.196.35 3.148-2.863 5.504-4.58 5.196z"
        fill="#000"
      />
    </svg>
  );
};

const jsIcon = () => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1h22v22H1V1z" fill="#F7DF1E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.779 18.188l-1.684.975c.606 1.196 1.846 2.111 3.766 2.111 1.964 0 3.426-1.018 3.426-2.88 0-1.727-.99-2.495-2.747-3.248l-.517-.222c-.886-.384-1.27-.635-1.27-1.255 0-.502.384-.886.99-.886.59 0 .974.251 1.329.886l1.61-1.034c-.68-1.196-1.625-1.654-2.94-1.654-1.845 0-3.027 1.182-3.027 2.732 0 1.684.99 2.481 2.481 3.116l.517.222c.945.413 1.506.664 1.506 1.373 0 .59-.546 1.02-1.402 1.02-1.02 0-1.595-.532-2.038-1.256zm-8.994 1.196zm0 0c.487 1.034 1.447 1.89 3.1 1.89 1.832 0 3.087-.974 3.087-3.116V11.1h-2.067v7.03c0 1.033-.428 1.299-1.108 1.299-.708 0-1.004-.488-1.329-1.063l-1.683 1.018z"
        fill="#000"
      />
    </svg>
  );
};

const reactIcon = () => {
  return (
    <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.681 8.221a16.092 16.092 0 00-.772-.243c.043-.179.083-.354.12-.527.584-2.84.201-5.126-1.104-5.88-1.252-.721-3.3.032-5.368 1.831-.199.173-.398.357-.597.549-.133-.127-.266-.25-.398-.368-2.167-1.924-4.34-2.735-5.644-1.98-1.251.724-1.621 2.874-1.095 5.565.05.26.11.525.177.795-.307.087-.604.18-.888.279-2.54.886-4.164 2.274-4.164 3.714 0 1.488 1.743 2.98 4.39 3.884.208.072.425.14.648.203-.072.292-.136.578-.188.857-.502 2.644-.11 4.743 1.137 5.462 1.289.743 3.451-.02 5.557-1.861.166-.146.333-.3.5-.462.218.21.434.407.65.592 2.04 1.756 4.054 2.464 5.3 1.743 1.287-.745 1.706-3 1.163-5.744-.042-.21-.09-.424-.144-.642.152-.044.3-.09.446-.139 2.751-.912 4.541-2.385 4.541-3.893 0-1.445-1.675-2.843-4.267-3.735zm-.596 6.655c-.132.043-.266.085-.404.126a24.062 24.062 0 00-1.215-3.04c.479-1.032.873-2.042 1.168-2.997.246.071.484.146.714.225 2.22.765 3.575 1.895 3.575 2.766 0 .928-1.463 2.132-3.838 2.92zm-.986 1.953c.24 1.213.274 2.31.115 3.167-.143.77-.43 1.284-.786 1.49-.756.438-2.373-.131-4.118-1.632-.2-.172-.401-.356-.603-.55a24.09 24.09 0 002.011-2.555 23.938 23.938 0 003.251-.5c.049.197.092.39.13.58zM9.13 21.41c-.74.262-1.328.269-1.684.064-.757-.437-1.071-2.122-.642-4.383.05-.26.108-.525.175-.797.983.218 2.071.374 3.234.468.664.935 1.36 1.793 2.06 2.546-.152.147-.305.288-.457.42-.93.815-1.864 1.392-2.686 1.682zm-3.462-6.54c-1.17-.4-2.137-.92-2.8-1.487-.595-.51-.895-1.016-.895-1.427 0-.874 1.303-1.988 3.476-2.746.263-.092.54-.179.826-.26.3.977.694 1.998 1.17 3.031a24.98 24.98 0 00-1.185 3.074c-.204-.058-.402-.12-.592-.185zm1.16-7.9c-.45-2.305-.151-4.043.602-4.48.803-.465 2.579.198 4.45 1.86.12.106.24.217.36.332a24.565 24.565 0 00-2.044 2.53c-1.129.105-2.21.273-3.203.498a15.035 15.035 0 01-.165-.74zm10.353 2.557a32.69 32.69 0 00-.73-1.2c.766.096 1.5.225 2.188.382a21.903 21.903 0 01-.768 2.067 35.7 35.7 0 00-.69-1.25zM12.96 5.415c.473.512.946 1.084 1.412 1.705a30.193 30.193 0 00-2.836 0 22.62 22.62 0 011.424-1.705zM8.711 9.534a30.32 30.32 0 00-.677 1.24 22.623 22.623 0 01-.763-2.076 23.111 23.111 0 012.176-.373c-.252.393-.498.796-.736 1.209zm.758 6.127a21.823 21.823 0 01-2.212-.356 23.02 23.02 0 01.778-2.119 30.302 30.302 0 001.434 2.474zm3.52 2.909a23.035 23.035 0 01-1.445-1.728c.46.018.928.027 1.404.027.49 0 .973-.011 1.45-.032a21.83 21.83 0 01-1.41 1.733zm4.893-5.42c.32.73.591 1.438.806 2.11-.696.16-1.447.287-2.239.382a32.592 32.592 0 001.433-2.493zm-1.584.759c-.375.65-.76 1.271-1.152 1.857-.712.051-1.448.078-2.198.078-.746 0-1.473-.024-2.172-.069a28.842 28.842 0 01-2.197-3.794 28.818 28.818 0 012.185-3.787 28.836 28.836 0 014.375 0 30.85 30.85 0 011.155 1.847 33.6 33.6 0 011.035 1.925 30.91 30.91 0 01-1.031 1.943zm2.115-11.45c.803.464 1.116 2.333.611 4.784a13.49 13.49 0 01-.108.478 24.56 24.56 0 00-3.209-.507 24.07 24.07 0 00-2.029-2.532c.185-.178.369-.347.552-.507 1.772-1.542 3.428-2.15 4.183-1.715zm-3.321 9.498a2.143 2.143 0 10-4.287 0 2.143 2.143 0 004.287 0z"
        fill="#4DB7E8"
      />
    </svg>
  );
};

const frameworkTypeToIconAsset = {
  android: {
    category: 'icon',
    colorable: false,
    name: 'android',
    svg: androidIcon,
  },
  ios: {
    category: 'icon',
    colorable: false,
    name: 'ios',
    svg: iosIcon,
  },
  js: {
    category: 'icon',
    colorable: false,
    name: 'js',
    svg: jsIcon,
  },
  react: {
    category: 'icon',
    colorable: false,
    name: 'react',
    svg: reactIcon,
  },
};

export const FrameworkIcon = ({type}: FrameworkIconProps) => {
  return (
    <Box padding={{right: 4}} flex={{display: 'inline-flex'}}>
      <SailIcon
        icon={frameworkTypeToIconAsset[type]}
        style={{display: 'inline'}}
      />
    </Box>
  );
};
